import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_information_heading extends PureComponent {
  render() {
    return (
      <div className="row" id="component_information_heading">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Information Heading</h2>
              <p>
                Information Headings are a simple way of adding a title or bold
                line of text to a record, dashboard, report, or search page.
                Information headings support multiple colors and different sizes
                of text.
              </p>

              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <InterfaceProperties
                type={"information_heading"}
                name={"heading"}
                padding={true}
                hide={true}
                order={true}
                properties={[
                  {
                    property: "heading_type",
                    description: "Different heading types and sizes.",
                    defaults:
                      '"heading1", "heading2", "heading3" or "heading4" default is "heading1"'
                  },
                  {
                    property: "heading_color",
                    description: "Set the color of the text.",
                    defaults:
                      '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                  },
                  {
                    property: "text",
                    description:
                      "Text that will be displayed inside the heading.",
                    defaults: '"My heading text here"'
                  }
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Information Heading Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Heading</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"information_heading"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"heading_color"</span>:{" "}
                  <span className="jsonY">"#F44336"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"heading_type"</span>:{" "}
                  <span className="jsonY">"heading2"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"text"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_information_heading;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_information_heading.js